export const SuggestionIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 12v-.75c0-.906.986-1.763 1.625-2.375.901-.862 1.375-2.019 1.375-3.375C12.5 3 10.508 1 8 1a4.488 4.488 0 00-4.5 4.5c0 1.308.494 2.543 1.375 3.375.636.6 1.625 1.46 1.625 2.375V12M7 15h2M6.5 13.5h3M8 12V8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.188 7.5S8.514 8 8 8c-.515 0-1.188-.5-1.188-.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
